export default {"src":"/_next/static/media/BRZE.176b1cfa.svg","height":18,"width":18};